"use strict";

var keyMirror = require('keymirror');

module.exports = keyMirror({
LOADING_LANGUAGE:null,
LOAD_LANGUAGE_LIST:null,
LOAD_LANGUAGE_SUCCESS:null,
LOAD_LANGUAGE_FAILURE:null,
LOAD_LANGUAGE:null,


});



/** WEBPACK FOOTER **
 ** ./modules/constants/LanguageConstants.js
 **/